import { Link } from "react-router";
import { Callout } from "../components";

export function Home() {
  return (
    <>
      <h1>TAIGA</h1>

      <p>
        Every platform shift creates a defining company. The internet created
        Google. Cloud created AWS. Mobile created the app economy.
      </p>
      <p>
        The agentic AI shift is next — and the governance layer is wide open.
      </p>

      <Callout variant="quote" title="Vision">
        Business intent in. Production software out. Fully governed.
      </Callout>

      <p>
        TAIGA is building the operating system for enterprise AI software
        development. Business intent goes in. Production software comes out.
        Every step governed, auditable, and traceable to business objectives.
      </p>
      <p>
        We are four founders who built Cloud2 from zero to EUR 30M+ revenue,
        150 people, and a PE exit — bootstrapped, profitable the entire way.
        Now we are building something bigger.
      </p>

      <Callout variant="success" title="Current Status">
        <p>
          <strong>Raising EUR 2M at EUR 20M pre-money.</strong> First customer
          contracts signed — including a publicly traded enterprise. EUR 10k+
          MRR closing within weeks of incorporation.
        </p>
      </Callout>

      <hr />

      <h2>Contents</h2>
      <ul>
        <li>
          <strong>
            <Link to="/opportunity">The Opportunity</Link>
          </strong>{" "}
          — Market, competitive landscape, EU AI Act
        </li>
        <li>
          <strong>
            <Link to="/team">The Team</Link>
          </strong>{" "}
          — Founders, Cloud2 track record, advisors
        </li>
        <li>
          <strong>
            <Link to="/product">The Product</Link>
          </strong>{" "}
          — Three Loops, LFA governance, six AI agents
        </li>
        <li>
          <strong>
            <Link to="/technology">Technology</Link>
          </strong>{" "}
          — Architecture, AWS infrastructure, security stack
        </li>
        <li>
          <strong>
            <Link to="/traction">Traction</Link>
          </strong>{" "}
          — Signed customers, velocity, milestones
        </li>
        <li>
          <strong>
            <Link to="/business">The Business</Link>
          </strong>{" "}
          — Outcome-as-a-Service, unit economics, GTM
        </li>
        <li>
          <strong>
            <Link to="/financials">Financials</Link>
          </strong>{" "}
          — Projections, funding rounds, sensitivity analysis
        </li>
        <li>
          <strong>
            <Link to="/cap-table">Cap Table</Link>
          </strong>{" "}
          — Ownership, CLA conversion, dilution waterfall
        </li>
        <li>
          <strong>
            <Link to="/governance">Governance</Link>
          </strong>{" "}
          — Security posture, ISMS, compliance, risk register
        </li>
        <li>
          <strong>
            <Link to="/legal">Legal</Link>
          </strong>{" "}
          — Corporate structure, CLA template, IP, regulatory
        </li>
        <li>
          <strong>
            <Link to="/faq">FAQ</Link>
          </strong>{" "}
          — 25 questions on team, product, business, risk
        </li>
      </ul>

      <hr />

      <p>
        <em>
          This data room is confidential. Access is restricted to invited
          parties.
        </em>
      </p>
    </>
  );
}
